import { Component, OnInit } from "@angular/core";
import { AuthService } from "./services/auth.service";
import { BootstrapService } from "./services/bootstrap.service";
import { OktaAuthService } from "@okta/okta-angular";
import { interval, Subscription } from "rxjs";
import { DialogService } from "./services/dialog.service";
import { MatDialog } from "@angular/material";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "rdb-project";

  private subscription: Subscription | undefined;
  private alertShown: boolean = false;

  constructor(
    protected authService: AuthService,
    private bootstrapService: BootstrapService,
    private oktaAuthService: OktaAuthService,
    public dialogService: DialogService,
    protected dialog: MatDialog
  ) {}
  ngOnInit() {
    // this.authService.signedInFlag = true;
    this.oktaAuthService.setFromUri("/default-redirect");
    this.bootstrapService.callServices();

    this.subscription = interval(60000).subscribe(() => {
      this.checkTokenExpiration();
    });
  }

  checkTokenExpiration() {
    const popupThreshold = 32;  // 28 mins elapsed
    const logoutThreshold = 30;

    this.oktaAuthService.isAuthenticated().then((isAuthenticated: boolean) => {

      if (!isAuthenticated) {
        return;
      }

      this.authService.getOktaTokenExpirationTime().subscribe(
        (response) => {

          const minutesLeft = parseInt(response?.body?.Minutes.replace(' minutes', ''), 10);

          if (minutesLeft <= popupThreshold && !this.alertShown) {
            this.alertShown = true;
            const message = 'As per company policy, your session will expire soon.\nTo remain logged in, you must extend your session using the button below.';
            const dialogRef = this.dialogService.openExpirationTimeConfirmDialog(
              'Session Renewal Notification',
              message,
              120
            );
            dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
              if (!isConfirmed) return;
              this.authService.renewAccessToken()
                .then(() => {
                  console.log('Access token renewed successfully');
                })
                .catch(err => console.error('Error renewing access token:', err));
            });
          }

          if (minutesLeft <= logoutThreshold) {
            this.authService.logout();
            return;
          }

          if (minutesLeft > popupThreshold) {
            this.alertShown = false;
          }
        },
        error => console.error('Error fetching token expiration time:', error)
      );

    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
